import { render, staticRenderFns } from "./Registrants.vue?vue&type=template&id=5f58db53&scoped=true"
import script from "./Registrants.vue?vue&type=script&lang=js"
export * from "./Registrants.vue?vue&type=script&lang=js"
import style0 from "./Registrants.vue?vue&type=style&index=0&id=5f58db53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58db53",
  null
  
)

export default component.exports